enum LIBRARY_REPORTS {
	EBOOK_REPORTS = '/api/libraryReports/eBooks',
	ISSUANCES_REPORTS = '/api/libraryReports/issuances',
	UNRETURNED_REPORTS = '/api/libraryReports/unreturned',
	UNRETURNED_REPORTS_PER_STUDENT = '/api/libraryReports/unreturned/students',
	UNRETURNED_REPORTS_PER_USER = '/api/libraryReports/unreturned/users',
	ROOMS_REPORTS = '/api/libraryReports/rooms',
	PRINTING_REPORTS = '/api/libraryReports/printing',
	ISSUANCE_PER_STUDENT = '/api/libraryReports/issuances/students',
	EBOOK_PER_STUDENT = '/api/libraryReports/ebooks/students',
	ISSUANCE_PER_USER = '/api/libraryReports/issuances/users',
	EBOOK_PER_USER = '/api/libraryReports/ebooks/users',

	EBOOK_REPORTS_XLSX = '/api/libraryReports/eBooks/export/xlsx',
	ISSUANCES_REPORTS_XLSX = '/api/libraryReports/issuances/export/xlsx',
	UNRETURNED_REPORTS_XLSX = '/api/libraryReports/unreturned/export/xlsx',
	UNRETURNED_REPORTS_PER_STUDENT_XLSX = '/api/libraryReports/unreturned/students/export/xlsx',
	UNRETURNED_REPORTS_PER_USER_XLSX = '/api/libraryReports/unreturned/users/export/xlsx',
	ROOMS_REPORTS_XLSX = '/api/libraryReports/rooms/export/xlsx',
	PRINTING_REPORTS_XLSX = '/api/libraryReports/printing/export/xlsx',
	ISSUANCE_PER_STUDENT_XLSX = '/api/libraryReports/issuances/students/export/xlsx',
	EBOOK_PER_STUDENT_XLSX = '/api/libraryReports/ebooks/students/export/xlsx',
	ISSUANCE_PER_USER_XLSX = '/api/libraryReports/issuances/users/export/xlsx',
	EBOOK_PER_USER_XLSX = '/api/libraryReports/ebooks/users/export/xlsx',
	PACKAGE_BOOKS_REPORTS = '/api/libraryReports/packageBooks'
}

export default LIBRARY_REPORTS;
